// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderComponent_container__Jq7jO {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  background-color: #ffffff;
  margin-left: 10px;
  margin-right: 10px;
}

.HeaderComponent_areaIzquierda__FeWd6 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.HeaderComponent_nombre__d2zL4 {
  margin-right: 10px;
  color: var(--text-color);
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 0px;
  padding-top: 0px;
}

.HeaderComponent_areaIzquierda__FeWd6 img {
  display: none;
}

.HeaderComponent_areaDerecha__mG5C0 {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.HeaderComponent_perfilContainer__m-fvD {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  height: 60px;
  background-color: var(--primary-color-seleccionado);
  border-radius: 30px;
  margin-left: 20px;
}

.HeaderComponent_perfilContainer__m-fvD:hover {
  background-color: var(--primary-color);
  cursor: pointer;
}

.HeaderComponent_perfilContainer__m-fvD:hover .HeaderComponent_iconoConfiguracion__pFVi9 {
  stroke: #ffffff;
}

.HeaderComponent_iconoConfiguracion__pFVi9 {
  width: 30px;
  height: 30px;
  stroke: var(--primary-color);
}
.HeaderComponent_circleImage__mtkxS {
  width: 40px; /* Ajusta el tamaño según tus necesidades */
  height: 40px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */
  border-radius: 50%; /* Esto crea el círculo */
  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */
  margin-right: 20px;
}

@media (min-width: 600px) {
  .HeaderComponent_areaIzquierda__FeWd6 img {
    display: block;
    width: 100px;
    margin-left: 10px;
    margin-right: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/principal/header/HeaderComponent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mDAAmD;EACnD,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,WAAW,EAAE,2CAA2C;EACxD,YAAY,EAAE,8EAA8E;EAC5F,kBAAkB,EAAE,yBAAyB;EAC7C,iBAAiB,EAAE,wEAAwE;EAC3F,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  justify-content: space-between;\n  height: 70px;\n  background-color: #ffffff;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.areaIzquierda {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.nombre {\n  margin-right: 10px;\n  color: var(--text-color);\n  font-weight: bold;\n  margin-top: 0px;\n  margin-bottom: 0px;\n  padding-top: 0px;\n}\n\n.areaIzquierda img {\n  display: none;\n}\n\n.areaDerecha {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.perfilContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 20px;\n  padding-right: 20px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  height: 60px;\n  background-color: var(--primary-color-seleccionado);\n  border-radius: 30px;\n  margin-left: 20px;\n}\n\n.perfilContainer:hover {\n  background-color: var(--primary-color);\n  cursor: pointer;\n}\n\n.perfilContainer:hover .iconoConfiguracion {\n  stroke: #ffffff;\n}\n\n.iconoConfiguracion {\n  width: 30px;\n  height: 30px;\n  stroke: var(--primary-color);\n}\n.circleImage {\n  width: 40px; /* Ajusta el tamaño según tus necesidades */\n  height: 40px; /* Asegúrate de que el alto y el ancho sean iguales para un círculo perfecto */\n  border-radius: 50%; /* Esto crea el círculo */\n  object-fit: cover; /* Asegura que la imagen cubra completamente el espacio sin deformarse */\n  margin-right: 20px;\n}\n\n@media (min-width: 600px) {\n  .areaIzquierda img {\n    display: block;\n    width: 100px;\n    margin-left: 10px;\n    margin-right: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HeaderComponent_container__Jq7jO`,
	"areaIzquierda": `HeaderComponent_areaIzquierda__FeWd6`,
	"nombre": `HeaderComponent_nombre__d2zL4`,
	"areaDerecha": `HeaderComponent_areaDerecha__mG5C0`,
	"perfilContainer": `HeaderComponent_perfilContainer__m-fvD`,
	"iconoConfiguracion": `HeaderComponent_iconoConfiguracion__pFVi9`,
	"circleImage": `HeaderComponent_circleImage__mtkxS`
};
export default ___CSS_LOADER_EXPORT___;
